<template>
  <div>
    <div class="top">
      <div class="plan" @click="cancel">广告计划</div>
      <div>></div>
      <div class="new" v-text="(type === 'add' ? '新建' : '编辑') + '广告单元'"></div>
    </div>
    <div class="create-plan">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <div class="form-title">基本属性</div>
        <el-form-item label="上传图片">
          <el-upload action="" ref="upload" class="avatar-uploader" :show-file-list="false" :on-change="logoUpload">
            <img v-if="form.video_path" :src="getImage(form.video_path)" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="所属计划" prop="plan_id">
          <el-select v-model="form.plan_id" placeholder="请选择计划" style="width: 350px;">
            <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属推广组" prop="group_id">
          <el-select v-model="form.group_id" placeholder="请选择推广组名称" style="width: 350px;">
            <el-option :label="item.group_name" :value="item.group_id" v-for="(item, index) in groupLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="创意名称" prop="adv_name">
          <el-input v-model="form.adv_name" placeholder="创意名称" style="width: 350px;"></el-input>
        </el-form-item> -->
        <el-form-item label="单元标题" prop="adv_title">
          <el-input v-model="form.adv_title" placeholder="单元标题" style="width: 350px;"></el-input>
        </el-form-item>

        <div class="form-title">哪些用户可以看到我的广告</div>
        <el-form-item label="地区选择">
          <el-radio-group v-model="other.city">
            <el-radio border label="1">不限</el-radio>
            <el-radio border label="2">定向</el-radio>
          </el-radio-group>
          <div>
            <el-cascader v-if="other.city === '2'" :options="options" :props="props" v-model="other.city_i" clearable collapse-tags style="width: 350px; margin-top: 20px;"></el-cascader>
          </div>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="other.sex">
            <el-radio border label="1">不限</el-radio>
            <el-radio border label="2">男</el-radio>
            <el-radio border label="3">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <el-radio-group v-model="other.ageTop">
            <el-radio border label="1">不限</el-radio>
            <el-radio border label="2">定向</el-radio>
          </el-radio-group>
          <el-checkbox-group v-model="other.age" v-if="other.ageTop === '2'" style=" margin-top: 20px;">
            <el-checkbox label="1">0-17</el-checkbox>
            <el-checkbox label="2">18-24</el-checkbox>
            <el-checkbox label="3">25-34</el-checkbox>
            <el-checkbox label="4">35-44</el-checkbox>
            <el-checkbox label="5">45-54</el-checkbox>
            <el-checkbox label="6">55+</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="兴趣定向">
          <el-radio-group v-model="other.page">
            <el-radio border label="1">不限</el-radio>
            <el-radio border label="2">定向</el-radio>
          </el-radio-group>
          <div>
            <el-cascader v-if="other.page === '2'" :options="peopleOpt" :props="props" v-model="other.people" clearable collapse-tags style="width: 350px; margin-top: 20px;"></el-cascader>
          </div>
        </el-form-item>
        <el-form-item label="广告位可见级别定向">
          <el-radio-group v-model="other.classTop">
            <el-radio border label="1">不限</el-radio>
            <el-radio border label="2">定向</el-radio>
          </el-radio-group>
          <el-checkbox-group v-model="other.class" v-if="other.classTop === '2'" style="margin-top: 20px;">
            <el-checkbox label="1">第一级</el-checkbox>
            <el-checkbox label="2">第二级</el-checkbox>
            <el-checkbox label="3">第三级</el-checkbox>
            <el-checkbox label="4">第四级</el-checkbox>
            <el-checkbox label="5">第五级</el-checkbox>
          </el-checkbox-group>

        </el-form-item>
        <div class="form-title">用户在哪里可以看到我的广告</div>
        <div class="form-title" style="font-size: 14px; margin-left: 30px;">移动设备定向</div>
        <el-form-item label="移动设备投放">
          <el-radio-group v-model="other.mobile_system">
            <el-radio border label="1">关闭</el-radio>
            <el-radio border label="2">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="other.mobile_system == '2'">
          <el-form-item label="操作系统定向">
            <el-radio-group v-model="other.systemTop">
              <el-radio border label="1">不限</el-radio>
              <el-radio border label="2">定向</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="other.system" v-if="other.systemTop === '2'" style="margin-top: 20px;">
              <el-checkbox label="1">iPhone</el-checkbox>
              <el-checkbox label="2">Android</el-checkbox>
              <el-checkbox label="3">iPad</el-checkbox>
              <el-checkbox label="4">Window Phone</el-checkbox>
              <el-checkbox label="5">Android Pad</el-checkbox>
              <el-checkbox label="6">TV</el-checkbox>
              <el-checkbox label="7">Other</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="运营商定向">
            <el-radio-group v-model="other.networkTop">
              <el-radio border label="1">不限</el-radio>
              <el-radio border label="2">定向</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="other.network" v-if="other.networkTop === '2'" style="margin-top: 20px;">
              <el-checkbox label="1">移动</el-checkbox>
              <el-checkbox label="2">联通</el-checkbox>
              <el-checkbox label="3">电信</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="网络环境定向">
            <el-radio-group v-model="other.serviceTop">
              <el-radio border label="1">不限</el-radio>
              <el-radio border label="2">定向</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="other.service" v-if="other.serviceTop === '2'" style="margin-top: 20px;">
              <el-checkbox label="1">WiFi</el-checkbox>
              <el-checkbox label="2">4G</el-checkbox>
              <el-checkbox label="3">3G</el-checkbox>
              <el-checkbox label="4">2G</el-checkbox>
              <el-checkbox label="5">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="手机厂商定向">
            <el-radio-group v-model="other.phoneTop">
              <el-radio border label="1">不限</el-radio>
              <el-radio border label="2">定向</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="other.phone" v-if="other.phoneTop === '2'" style="margin-top: 20px;">
              <el-checkbox label="1">苹果</el-checkbox>
              <el-checkbox label="2">华为</el-checkbox>
              <el-checkbox label="3">360</el-checkbox>
              <el-checkbox label="4">oppo</el-checkbox>
              <el-checkbox label="5">vivo</el-checkbox>
              <el-checkbox label="6">荣耀</el-checkbox>
              <el-checkbox label="7">小米</el-checkbox>
              <el-checkbox label="8">三星</el-checkbox>
              <el-checkbox label="9">魅族</el-checkbox>
              <el-checkbox label="10">一加</el-checkbox>
              <el-checkbox label="11">努比亚</el-checkbox>
              <el-checkbox label="12">联想</el-checkbox>
              <el-checkbox label="13">美图</el-checkbox>
              <el-checkbox label="14">中兴</el-checkbox>
              <el-checkbox label="15">HTC</el-checkbox>
              <el-checkbox label="16">酷派</el-checkbox>
              <el-checkbox label="17">锤子</el-checkbox>
              <el-checkbox label="18">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="form-title" style="font-size: 14px; margin-left: 30px;">PC设备定向</div>
        <el-form-item label="PC设备投放">
          <el-radio-group v-model="other.pc_system">
            <el-radio border label="1">关闭</el-radio>
            <el-radio border label="2">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="other.pc_system == '2'">
          <el-form-item label="操作系统定向">
            <el-radio-group v-model="other.pcSystemTop">
              <el-radio border label="1">不限</el-radio>
              <el-radio border label="2">定向</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="other.pcSystem" v-if="other.pcSystemTop === '2'" style="margin-top: 20px;">
              <el-checkbox label="1">Windows</el-checkbox>
              <el-checkbox label="2">Mac</el-checkbox>
              <el-checkbox label="3">Linux</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="浏览器定向">
            <el-radio-group v-model="other.browserTop">
              <el-radio border label="1">不限</el-radio>
              <el-radio border label="2">定向</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="other.browser" v-if="other.browserTop === '2'" style="margin-top: 20px;">
              <el-checkbox label="1">IE8</el-checkbox>
              <el-checkbox label="2">IE9</el-checkbox>
              <el-checkbox label="3">IE10</el-checkbox>
              <el-checkbox label="4">IE11</el-checkbox>
              <el-checkbox label="5">Chrome</el-checkbox>
              <el-checkbox label="6">Firefox</el-checkbox>
              <el-checkbox label="7">Safari</el-checkbox>
              <el-checkbox label="8">Opera</el-checkbox>
              <el-checkbox label="9">baidu</el-checkbox>
              <el-checkbox label="10">The World</el-checkbox>
              <el-checkbox label="11">Sogou</el-checkbox>
              <el-checkbox label="12">QQ</el-checkbox>
              <el-checkbox label="13">360</el-checkbox>
              <el-checkbox label="14">遨游</el-checkbox>
              <el-checkbox label="15">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="form-title">广告投放出价</div>
        <el-form-item label="默认出价" prop="price">
          <el-input placeholder="默认出价,最低0.6" v-model="form.price" style="width: 350px; margin-right: 10px;">
            <template slot="append">CNY</template>
          </el-input>
          <el-radio-group v-model="form.type">
            <el-radio border label="1">CPM</el-radio>
            <el-radio border label="2">CPC</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form', 'advCancel')">确 定</el-button>
          <el-button @click="cancel">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import options from '../../../plugin/city_code.js';
import peopleOpt from '../../../plugin/people_type.js';
export default {
  name: 'createAdv',
  props: ['adv_data'],
  data() {
    return {
      form: {
        adv_id: '',
        plan_id: '',
        group_id: '',
        adv_title: '',
        suffix: '',
        video_path: '',
        type: '1',
        price: ''
      },
      other: {
        city: '1',
        sex: '1',
        ageTop: '1',
        age: [],
        page: '1',
        classTop: '1',
        class: [],
        mobile_system: '2',
        systemTop: '1',
        system: [],
        networkTop: '1',
        network: [],
        serviceTop: '1',
        service: [],
        phoneTop: '1',
        phone: [],
        pc_system: '2',
        pcSystemTop: '1',
        pcSystem: [],
        browserTop: '1',
        browser: []
      },
      props: { multiple: true, children: 'city', value: 'code', label: 'name' },
      options: options,
      peopleOpt: peopleOpt,
      type: 'add',
      rules: {
        plan_id: [
          { required: true, message: '请选择计划', trigger: 'change' }
        ],
        group_id: [
          { required: true, message: '请选择推广组', trigger: 'change' }
        ],
        adv_title: [
          { required: true, message: '请输入创意标题', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入出价', trigger: 'blur' }
        ]
      },
      planLists: [],
      groupLists: []
    };
  },
  created() {
    if (this.adv_data.adv_id !== undefined && parseInt(this.adv_data.adv_id) > 0) {
      this.form = {
        adv_id: this.adv_data.adv_id,
        plan_id: this.adv_data.plan_id,
        group_id: this.adv_data.group_id,
        adv_title: this.adv_data.adv_title,
        price: this.adv_data.price,
        suffix: '',
        video_path: this.adv_data.video_path,
        type: this.adv_data.type + ''
      };
      this.other = this.adv_data.get_info;
      this.type = 'edit';
    }
    this.$http.post('/trader/index/group_form').then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
      }
    });
    this.$function.hiddenLoading();
  },
  methods: {
    getGroupLists(plan_id) {
      return new Promise((resolve, reject) => {
        try {
          this.$http.post('/trader/index/getGroupForPlanId', {
            plan_id
          }).then(res => {
            resolve(res);
          });
        } catch (e) {
          reject({ code: 500, msg: '未知错误' });
        }
      });
    },
    submitForm(formName, make) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.video_path === '') {
            this.$message.error('请上传图片');
            return false;
          }
          if (parseFloat(this.form.price) < 0.6) {
            this.$message.error('出价最低0.6');
            return false;
          }
          const url = this.type === 'add' ? '/trader/index/createAdv' : '/trader/index/saveAdv';
          this.form = Object.assign({}, this.form, { get_info: this.other });
          this.$http.post(url, this.form).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('plan_call_back', make);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$emit('plan_call_back', 'advCancel');
    },
    logoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }
      if (file.raw.type.includes('gif')) {
        this.$message.error('图片格式不能是GIF');
        return;
      }

      this.$function.blobToDataURL(file.raw, res => {
        const imgType = file.raw.type.split('/');
        this.form.suffix = imgType[1];
        this.form.video_path = res;
      });
    },
    getImage(logo) {
      return logo.includes('base64,') ? logo : this.$Config.apiUrl + logo;
    }
  },
  watch: {
    'form.plan_id'(newVal, oldVal) {
      this.getGroupLists(newVal).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped="">
  .form-title {
    color: #00A1D6;
    line-height: 20px;
    font-size: 16px;
    border-left: 2px solid #00A1D6;
    padding-left: 8px;
    margin-bottom: 40px;
  }
  .create-plan {
    background: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    border-radius: 4px;
    padding: 30px 20px 20px;
  }
  .top {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    height: 64px;
    font-size: 14px;
    color: #606266;
    background: #fff;
    padding: 0 25px;
    div {
      margin-right: 5px;
    }
    .plan:hover {
      cursor: pointer;
      color: #1890FF;
    }
  }
  .avatar-uploader {
    width: 135px;
    display: inline-block;
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409EFF;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    min-width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .avatar {
    min-width: 128px;
    height: 128px;
    display: block;
  }
</style>
